import store from 'store';
import request from '@/utils/request';
import Cookies from 'js-cookie';

const defaultSystemConfig = {
  plan_001: false, // 是否可以新增临时计划
  project_011: [], // 资格审查人员
  project_018: false, //是否配置采购费用
  project_019: false, //是否启用线上评审
};

const initState = {
  id: store.get('userId') || '',
  menu: store.get('userMenu') || [],
  currentMenuList: store.get('userCurrentMenuList') || [],
  wholeMenuList: store.get('userWholeMenuList') || [],
  info: store.get('userInfo') || {},
  type: store.get('userType') || '',
  mgrType: store.get('mgrType') || '',
  office: store.get('userOffice') || {},
  roleKeywords: new Set(store.get('userRoleKeywords')) || new Set(),
  systemConfig: store.get('systemConfig') || defaultSystemConfig,
  token: Cookies.get('mall-utk') || '',
  forceBindCa: store.get('userForceBindCa') || false,
};

export default {
  state: initState,
  reducers: {
    setId(userState, id) {
      store.set('userId', id);
      return { ...userState, id };
    },
    setCurrentMenuList(userState, currentMenuList) {
      store.set('userCurrentMenuList', currentMenuList);
      return { ...userState, currentMenuList };
    },
    setWholeMenuList(userState, wholeMenuList) {
      store.set('userWholeMenuList', wholeMenuList);
      return { ...userState, wholeMenuList };
    },
    setInfo(userState, info) {
      store.set('userInfo', info);
      return { ...userState, info };
    },
    setToken(userState, token) {
      Cookies.set('mall-utk', token);
      return { ...userState, token };
    },
    setSystemConfig(userState, systemConfig) {
      store.set('systemConfig', systemConfig);
      return { ...userState, systemConfig };
    },
    setForceBindCa(userState, forceBindCa) {
      store.set('userForceBindCa', forceBindCa);
      return { ...userState, forceBindCa };
    },
    setUserState(userState, { id, menu, info, office, roleKeywords }) {
      const forceBindCa = info.needBindCA && !info.isBindCA;
      store.set('userId', id);
      store.set('userMenu', menu);
      store.set('userInfo', info);
      store.set('userType', info.userType);
      store.set('mgrType', info.mgrType);
      store.set('userOffice', office);
      store.set('userRoleKeywords', roleKeywords);
      store.set('userForceBindCa', forceBindCa);
      return {
        ...userState,
        id,
        menu,
        info,
        office,
        type: info.userType,
        mgrType: info.mgrType,
        roleKeywords: new Set(roleKeywords),
        forceBindCa,
      };
    },
    reset() {
      return initState;
    },
  },
  effects: () => ({
    fetchCurrentMenuList() {
      return request.getWMessage('oauth-power-q-003', { menuTypes: ['10'] }).then((res) => {
        // /oauth/power/getCurrentUserMenuList
        this.setCurrentMenuList(res.data.map((i) => i.menuUrl));
      });
    },
    fetchWholeMenuList() {
      return request.getWMessage('system-menu-q-001').then((res) => {
        this.setWholeMenuList(res.data);
      });
    },
    fetchUserInfo() {
      return request.getWMessage('oauth-power-q-002').then((res) => {
        this.setUserState({
          id: res.data.id,
          menu: res.data.menus,
          info: res.data,
          office: res.data.office,
          roleKeywords: res.data.roleKeywords,
        });
        return res;
      });
    },
    fetchSystemConfig() {
      return request.getWMessage('system-brmResult-q-004').then((res) => {
        this.setSystemConfig(res.data);
      });
    },
    fetchAllInfo() {
      return Promise.all([
        this.fetchUserInfo(),
        // this.fetchSystemConfig(),
      ]);
    },
  }),
};
